var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"snackbar-main"}},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},_vm._l((_vm.$state.utils.snackbarMessages),function(message){return _c('div',{key:message.timestamp,staticClass:"snackbar-message"},[_c('span',[_vm._v(_vm._s(message.message))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }